import React from 'react'
import CommonNavbar from '../../components/CommonNavbar/CommonNavbar'
import CommonFooter from '../../components/CommonFooter/CommonFooter'

const BuyAgriEquipment = () => {
  return (
    <>
      <CommonNavbar />
      <div className='py-5'>
        <div className='container px-md-5'>
          <div className='p-8 bg-white'>
            <div className='max-w-5xl mx-auto'>
              {/* Header */}
              <h2 className='text-3xl font-bold text-gray-800 mb-4 clr_dark_green'>
                Explore a Wide Range of Agricultural Equipment
              </h2>
              <p className='text-gray-600 mb-8'>
                At Farmer’s City, we offer a diverse selection of high-quality
                agricultural equipment to meet the needs of farmers looking to
                enhance their farming operations. Our platform serves as a
                one-stop shop for all your agricultural equipment requirements,
                providing access to a variety of tools and machinery designed to
                improve efficiency and productivity on the farm.
              </p>

              {/* Services Offered */}
              <h3 className='text-2xl font-semibold text-gray-800 mb-4 clr_dark_green'>
                Services Offered for Buying Agri Equipment
              </h3>
              <ul className='list-disc pl-6 text-gray-700 mb-8 space-y-2'>
                <li>
                  <strong>Agri Equipment Marketplace:</strong> Browse through
                  our online marketplace to discover a range of agricultural
                  equipment such as tractors, harvesters, plows, seeders, and
                  more from trusted manufacturers and suppliers.
                </li>
                <li>
                  <strong>Custom Hiring Services:</strong> Partnering with
                  Rental as a Service (RaaS) platforms, we enable farmers to
                  rent or book agricultural machinery on a custom hiring basis,
                  offering flexibility and cost-effective solutions.
                </li>
                <li>
                  <strong>Machinery Sales:</strong> Connect with machinery
                  dealers onboarded on our platform to purchase new or used
                  agricultural equipment, with the option to sell or lease your
                  own machinery through our marketplace.
                </li>
                <li>
                  <strong>Commission Structure:</strong> Benefit from a
                  transparent commission-based model where we take a percentage
                  (5–20%) from machinery dealers for sales facilitated through
                  our platform.
                </li>
              </ul>

              {/* How to Purchase */}
              <h3 className='text-2xl font-semibold text-gray-800 mb-4 clr_dark_green'>
                How to Purchase Agri Equipment at Farmer’s City
              </h3>
              <ul className='list-disc pl-6 text-gray-700 mb-8 space-y-2'>
                <li>
                  <strong>Visit Our Online Marketplace:</strong> Explore our
                  e-commerce platform to view a wide range of agricultural
                  equipment available for purchase or rental.
                </li>
                <li>
                  <strong>Browse and Compare:</strong> Compare different
                  products based on specifications, prices, and reviews to make
                  an informed decision that suits your farming needs.
                </li>
                <li>
                  <strong>Place Your Order:</strong> Select the desired
                  equipment, add it to your cart, and proceed to checkout for a
                  seamless purchasing experience.
                </li>
                <li>
                  <strong>Secure Payment Options:</strong> Enjoy fast and secure
                  transactions through our integrated payment gateways such as
                  Razorpay/PayTM UPI for hassle-free payments.
                </li>
              </ul>

              {/* Franchise Opportunities */}
              <h3 className='text-2xl font-semibold text-gray-800 mb-4 clr_dark_green'>
                Franchise Opportunities for Agri Equipment Dealers
              </h3>
              <p className='text-gray-600 mb-6'>
                If you are a machinery dealer interested in expanding your reach
                and connecting with a wider customer base, consider partnering
                with Farmer’s City as an agri equipment supplier. By joining our
                platform, you can benefit from:
              </p>
              <ul className='list-disc pl-6 text-gray-700 mb-8 space-y-2'>
                <li>
                  Increased visibility and access to a large network of farmers
                  seeking agricultural equipment.
                </li>
                <li>
                  Commission-based sales opportunities that help you reach new
                  customers and grow your business.
                </li>
                <li>
                  Seamless integration with our e-commerce platform for
                  efficient transactions and order management.
                </li>
              </ul>

              {/* Closing */}
              <p className='text-gray-700 font-medium'>
                Join us in revolutionizing the way farmers access and purchase
                agricultural equipment, making farming operations more efficient
                and productive.
              </p>
            </div>
          </div>
        </div>
      </div>

      <CommonFooter />
    </>
  )
}

export default BuyAgriEquipment
